import { RootStateAccount } from "./accountStore";

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("account-state");
    if (serializedState === null) {
      return undefined;
    }
    return { Authentication: JSON.parse(serializedState) };
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state: RootStateAccount) => {
  try {
    const serializedState = JSON.stringify(state.Authentication);
    localStorage.setItem("account-state", serializedState);
  } catch (err) {
    // ignored
  }
};
